import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXGridComponent } from './grid.component';
import { UBXTrackComponent } from './track/track.component';

const Module = [
    UBXGridComponent,
    UBXTrackComponent,
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule
    ],
    exports: [
        Module
    ],
})
export class UBXGridModule {}
